const ar = {
  welcomeMessage: 'Welcome aboard',
  home: 'Home',
  theBill: 'The bill',
  choosePaymentMethod: 'Choose payment method',
  creditCard: 'Credit card',
  totalAmout: 'totalAmout',
  riyal: 'riyal',
  addNewCard: 'Add new card',
  firstName: 'First name',
  lastName: 'Last name',
  idNumber: 'Id number',
  cvv: 'CVV',
  cardNumber: 'Card number',
  expiryDate: 'Expiry date',
  registeredNameOnCard: 'Registered name on card',
  requestNumberIs: 'request number: {requestNumber}',
  unAvailable: 'unAvailable',
  individual: 'individual',
  establishment: 'establishment',
  hijriSuffix: 'H',
  gregorianSuffix: 'M',
  morningTimeFullSuffix: 'Morning',
  eveningTimeFullSuffix: 'Evening',
  requestDetails: 'requestDetails',

  alRajhiCardErrors: {
    'Please enter valid CardHolder First Name': 'Please enter valid CardHolder First Name',
    'Please enter valid CardHolder Last Name': 'Please enter valid CardHolder Last Name',
    'Please enter valid Card Number': 'Please enter valid Card Number',
    'Please enter valid Card Expiry Month': 'Please enter valid Card Expiry Month',
    'Please enter valid Card Expiry Year': 'Please enter valid Card Expiry Year',
    'Please enter valid CVV': 'Please enter valid CVV',
  },
  serverErrors: {
    SERVER_ERROR: 'Something went wrong',
    USER_NOT_FOUND: 'User is not found, please try again',
  },
};

export default ar;
